/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Bookmarks",
  "description": "Place an anchor point, and then you can teleport here at any time!",
  "credits": [
    {
      "name": "Cyberexplorer",
      "link": "https://github.com/lanwywritexu"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "userstyle.css"
    }
  ],
  "tags": [
    "new",
    "recommended"
  ],
  "enabledByDefault": true
};
export default manifest;